module.exports = __webpack_public_path__ + "img/logo@3x.701b96c1.png";